import * as functions from "../lib/helpers.js";

export default class posLoginForm {
    constructor()
    {
        this.$loginForm = $('#loginForm');
        this.init();
    }

    init()
    {
        this.initEvents();
        this.loadSelectedDevice();
        this.loadPosParams();
    }

    initEvents()
    {
        $('#forgotten-password-btn').on('click', (e) => {
            const url = e.currentTarget.dataset.url;
            const email = $('#email').val();
            axios.post(url, {email: email})
                .then((response) => {
                    if(response.data.success)
                    {
                        this.#displayAlert('Un courriel afin de réinitialiser votre mot de passe a été envoyé.', 'success');
                    }
                    else
                    {
                        this.#displayAlert(response.data.errors, 'error');
                    }
                })
                .catch((error) => {
                    let message = 'Une erreure inconnue est arrivée. Veuillez réessayer plus tard.';
                    if (error.response.status === 422) {
                        message = error.response.data.message;
                    }
                    this.#displayAlert(message, 'error');
                });
        });
    }

    loadSelectedDevice()
    {
        this.selected_device_uid = window.localStorage.getItem('selected_device_uid');

        if(functions.isset(this.selected_device_uid))
        {
            this.$loginForm.append(
                    '<input type="hidden" name="selected_device_uid" value="' +
                    encodeURI(this.selected_device_uid) +
                    '">'
                );
        }
    }

    loadPosParams()
    {
        this.last_accessed_store_id = window.localStorage.getItem(
            'user.' + window.current_user_id + '.xpos.params.last-accessed-store'
        );

        if(functions.isset(this.last_accessed_store_id))
        {
            this.last_accessed_store_id = parseInt(this.last_accessed_store_id);

            if(this.last_accessed_store_id > 0)
            {
                this.$loginForm.append(
                    '<input type="hidden" name="last_accessed_store_id" value="' + this.last_accessed_store_id + '">'
                );
            }

        }
    }

    #displayAlert(p_message, p_type)
    {
        const alert = $('#login-alert');
        alert.removeClass('alert-danger');
        alert.removeClass('alert-success');
        alert.removeClass('d-none');

        if(p_type === 'error')
        {
            alert.addClass('alert-danger');
        }
        else
        {
            alert.addClass('alert-success')
        }

        alert.html(p_message);
    }

}
